  import DriverRow from "./DriverRow";
  import "../../styles/table.css";

  export default function DriverTable({ drivers, onView, onEdit, onDelete , onToggleApprove, onAssignOrderType }) {
    return (
      <div className="tableCard">
        <table className="modernTable">
          <thead>
            <tr>
              <th>Chauffeur</th>
             
              <th>Solde</th>
              <th>Statut</th>
              <th>Disponibilite</th>
              <th className="center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {drivers.map((driver) => (
              <DriverRow
                key={driver.id}
                driver={driver}
                onView={onView}
                onEdit={onEdit}
                onDelete={onDelete}
                onToggleApprove={onToggleApprove} 
                onAssignOrderType={onAssignOrderType}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
